<template>
  <router-view/>
</template>
<script>
const meta = document.createElement('meta')
meta.setAttribute('name', 'description')

export default {
  watch: {
    '$route' (to, from) {
      document.title = `${to.name} - abraao.dev`
      meta.setAttribute('content', `${document.title}. ${to.meta.description}`)
      document.head.appendChild(meta)
    }
  }
}
</script>
